import React from "react";
import { Link } from "react-router-dom";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    // A production storefront can report this through its monitoring provider.
  }

  render() {
    if (this.state.hasError) {
      return <main className="not-found shell"><p className="eyebrow">Something shifted</p><h1>This page couldn’t unfold.</h1><p>Refresh the page or return to the collection.</p><Link className="button button--dark" to="/shop">Back to shop</Link></main>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
